import { Accordian, EducationModal, Flex, InformationIcon, LabelText, NavItemTypography } from '@components';
import { BUILD_FLOW_STEPS, CUSTOMER_JOURNEYS } from '@constants';
import variables from '@styles/export.module.scss';
import { useBFContext } from '@context';
import { useEducationTabs, useTranslation } from '@utils/hooks';

interface AccordianProps {
	dataTags?: object;
	className?: string;
	customRowStyle?: string;
	isOpen: boolean;
	onClick: () => void;
	children: React.ReactNode;
	title: string;
	subtitle: string;
	containerClassName?: string;
	disableModal?: boolean;
	type: BUILD_FLOW_STEPS;
}
export default function QuickAddAccordion({
	dataTags,
	className,
	onClick,
	customRowStyle,
	children,
	isOpen,
	title,
	subtitle,
	containerClassName,
	type,
	disableModal = false,
}: AccordianProps) {
	const { translator } = useTranslation();
	const INFO_TAB_DESCRIPTION_COPY = translator('eye-safety-recommendation');
	const { journey } = useBFContext();
	const { educationModalProps } = useEducationTabs({
		isHandyModal: type === BUILD_FLOW_STEPS.CUSTOMIZE && journey !== CUSTOMER_JOURNEYS.SUNGLASSES,
	});

	return (
		<Accordian
			dataTags={dataTags}
			className={className}
			customRow={customRowStyle}
			isOpen={isOpen}
			onClick={onClick}
			iconStyle='caret'
			shouldRemoveBorder
			titleChildren={
				<>
					<Flex align='start' fullWidth gap={2}>
						<NavItemTypography shouldKeepTypography>{title}</NavItemTypography>
						<LabelText>-</LabelText>
						<LabelText color={variables.gray3}>{subtitle}</LabelText>
					</Flex>
					{!disableModal && (
						<Flex style={{ marginRight: '0.4rem' }} align='end' justify='end' onClick={e => e.stopPropagation()}>
							<EducationModal
								tab={0}
								trigger={<InformationIcon />}
								infoCopy={INFO_TAB_DESCRIPTION_COPY}
								{...educationModalProps}
							/>
						</Flex>
					)}
				</>
			}
		>
			<Flex column gap={3} className={containerClassName}>
				{children}
			</Flex>
		</Accordian>
	);
}
